export { default } from "../objectWithoutPropertiesLoose/_index.mjs"